import { useEffect } from 'react';

import { css } from '@compiled/react';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { useLoggedOut } from '@/components/user-context/helpers/cohorts';
import { wacToken } from '@/libraries/design/foundations';
import StickyContainer from '@/patterns/sticky-container/sticky-container';

import { experiments } from '../../../../../../utils/experiment/manifest';
import { useExperimentExposure } from '../../../../../../utils/experiment/use-experiment-exposure';
import { ParentScrollTracking } from '../../../../../../utils/scroll-tracking/parent-scroll-tracker';
import JiraSoftwareNav from '../../../sections/nav-bar/software-jira-navbar';

import { AiRefreshSection } from './ai-refresh-section';
import { JiraSoftwarePageBannerAlert } from './sections/banner-alert';
import { GartnerSection } from './sections/gartner-section';
import BuildAndSupportDoubleFeatureSection from './sections/productionized/build-and-support-double-feature';
import { ClosingBanner } from './sections/productionized/closing-banner';
import { Footer } from './sections/productionized/footer';
import { IntegrationsSection } from './sections/productionized/integrations';
import { JswCollaborateSection } from './sections/productionized/jsw-collaborate';
import { JswDoubleFeatureSection } from './sections/productionized/jsw-double-feature';
import { LoggedOutHeroSection } from './sections/productionized/logged-out-hero-section';
import { NoJiraHeroSection } from './sections/productionized/no-jira-hero-section';
import { TestimonialSection } from './sections/productionized/testimonial';

export const LoggedOutOrNoJiraProductTourOverview = () => {
	const isLoggedOut = useLoggedOut();
	const [jiraFflExposureFired, fireJiraFflExposure] = useExperimentExposure(
		experiments.cfind6469FrictionlessFirstLookJiraV3,
	);

	useEffect(() => {
		if (!jiraFflExposureFired) {
			fireJiraFflExposure();
		}
	}, [jiraFflExposureFired, fireJiraFflExposure]);

	let heroSection = <NoJiraHeroSection />;

	if (isLoggedOut) {
		heroSection = <LoggedOutHeroSection />;
	}

	return (
		<UFOSegment name="logged-out-no-jira-product-tour">
			<JiraSoftwarePageBannerAlert />
			<StickyContainer>
				<JiraSoftwareNav />
			</StickyContainer>
			<main css={sectionContainerStyles} data-testid="loggedOutNoJira" id="content">
				<ParentScrollTracking scrollTrackingEnabled={true} pageId="Jira">
					{heroSection}
					<GartnerSection />
					<JswCollaborateSection />
					<AiRefreshSection />
					<BuildAndSupportDoubleFeatureSection />
					<JswDoubleFeatureSection />
					<IntegrationsSection />
					<div css={backgroundStyles}>
						<TestimonialSection />
						<ClosingBanner />
					</div>
					<Footer />
				</ParentScrollTracking>
			</main>
		</UFOSegment>
	);
};

const sectionContainerStyles = css({
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
});

const backgroundStyles = css({
	backgroundColor: wacToken('color.primary.blue'),
});
